import type { FaireProductEntity } from "../../entity_types/product";

export const p_typpjyctcu: FaireProductEntity = {
  token: "p_typpjyctcu",
  type: "product",
  name: "Boxed Set of 4 Mini Lavender Heart Sachets",
  brandToken: "b_5qsb0hdt",
  brandName: "Belle's Nest",
  imageUrl:
    "https://cdn.faire.com/fastly/5c207a81c1dd24e455dbcae28ad5a4803ac99edb124ed77f6026e8d0423b8efb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7c4ccaaaf020b2f9074bb4abbf8139197fa5c775c9b660200e5c602d51d59361.jpeg",
  ],
  priceDollars: 20.89,
  description:
    'Boxed Set of 4 Mini Lavender Heart Sachets\n\nA nice option for those who are looking for a boxed gift.\nEach box will contain 4 Mini Lavender Heart Sachets/Tokens - Assorted colors and patterns.\n\n\nLavender filled, cotton printed fabric.\nAssorted patterns and colors will be packaged, minor size differences.\nHearts  - Approx 2 to 2 1/2" x 2 1/2"\nBox - 5 1/4 x 3 3/4 x 1"\n',
  tags: [],
  msrpDollars: 41.78,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:51.295Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
